import './utils/hamburger-animation.js';
import './utils/scroll-animation.js';
import type { createRoot as createRootType } from 'react-dom/client';
import './utils/animateLogo.js';
import {App} from './navigation-app.tsx';
import NavAlertsApp from './nav-alerts-app.tsx';
import UserNav from './components/UserNav.tsx';
import ArticleReadTime from './components/ArticleReadTime.tsx';

const React = window.React || null;
const ReactDOM = window.ReactDOM || null;
if( !React || !ReactDOM ) {
    throw new Error('React and ReactDOM are required for this plugin');
}

const { client } = ReactDOM;
const { createRoot } : { createRoot: typeof createRootType } = client;


// Conditionally load react component and render it on click of hamburger icon with id 'menu-icon'

function initNavigationApp() {

    const elNavRootEl = document.getElementById('nav-react-app');
    const elHamburgerIcon = document.getElementById('aw-nav-menu-icon');

    if( elHamburgerIcon && elNavRootEl ) {
        const root = createRoot(elNavRootEl);
        root.render(<App />);
    }
}

document.addEventListener('DOMContentLoaded', initNavigationApp, {
    once: true,
    passive: true
});

function initNavAlertApp() {

    const root = document.getElementById('adw-nav-alerts');
    if( root ) {
        const navAlertRoot = createRoot(root);
        navAlertRoot.render(<NavAlertsApp containerType="desktop" />);
    }
}

function initMobileNavAlertApp() {

    const mobileRoot = document.getElementById('adw-nav-alerts-mobile');
    if( mobileRoot ) {
        const mobileNavAlertRoot = createRoot(mobileRoot);
        mobileNavAlertRoot.render(<NavAlertsApp containerType="mobile" />);
    }
}

document.addEventListener('DOMContentLoaded', initNavAlertApp, {
    once: true,
    passive: true
});

document.addEventListener('DOMContentLoaded', initMobileNavAlertApp, {
    once: true,
    passive: true
});

function createActiveNavItem(){

    // Get the current URL
    const currentUrl = window.location.href;

    // Check if adw.nav_main.items array has item.object === 'vertical'
    // If so, check if item.url's last path segment matches the first path segment of the current URL

    const path = currentUrl.split('/').filter(Boolean);

    const elsNavItems = document.querySelectorAll('.adw-nav-list a');
    if( !elsNavItems?.length ) {
        return;
    }
    elsNavItems.forEach((elNavItem) => {
        const elNavItemUrl = elNavItem.getAttribute('href');
        if( !elNavItemUrl ) {
            return;
        }
        const navItemPath = elNavItemUrl.split('/').filter(Boolean);

        if( navItemPath?.[3] && navItemPath?.[2] === 'vertical' ){
            const isActive = path[2] === navItemPath[3];
            if( isActive ){
                elNavItem.classList.add('text-primary');
            }
        }

    })

}

document.addEventListener('DOMContentLoaded', createActiveNavItem, {
    once: true,
    passive: true
});

// Create User Nav menu inside .user-nav

function renderUserNavMenu() {
    const elUserNav = document.querySelector('.user-nav');
    if( !elUserNav ) {
        return;
    }

    const elRoot = ReactDOM.client.createRoot(elUserNav);
    const innerHtml = elUserNav.innerHTML;
    elRoot.render( <UserNav /> );
}

document.addEventListener('DOMContentLoaded', renderUserNavMenu, {
    once: true,
    passive: true
});

// Load Article Read Time
function renderArticleReadTime() {
    const elArticleReadTime = document.querySelector('.read-time');
    if( !elArticleReadTime ) {
        return;
    }

    const elRoot = ReactDOM.client.createRoot(elArticleReadTime);
    elRoot.render( <ArticleReadTime /> );
}
document.addEventListener('DOMContentLoaded', renderArticleReadTime, {
    once: true,
    passive: true
});